import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Hero = _resolveComponent("Hero")!
  const _component_About = _resolveComponent("About")!
  const _component_Experience = _resolveComponent("Experience")!
  const _component_Education = _resolveComponent("Education")!
  const _component_Skills = _resolveComponent("Skills")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_MobileNav = _resolveComponent("MobileNav")!
  const _component_ScrollTop = _resolveComponent("ScrollTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("main", null, [
      _createVNode(_component_Hero),
      _createVNode(_component_About),
      _createVNode(_component_Experience),
      _createVNode(_component_Education),
      _createVNode(_component_Skills)
    ]),
    _createVNode(_component_Footer),
    _createVNode(_component_MobileNav),
    _createVNode(_component_ScrollTop)
  ], 64))
}